import {useTranslation} from '@/translations/i18n.tsx'
import {Assignment} from '@features/assignment/types.ts'
import {AssignmentCardLink} from '@features/assignment/components/assignment-card-link'
import {ASSIGNMENT_CARD_WRAPPER_CLASSNAME, ASSIGNMENT_CARD_TITLE_CLASSNAME} from '@features/assignment/constants'

export const AssignmentHostSubmissionsCard = ({assignment}: {assignment: Assignment}) => {
    const {t} = useTranslation()

    return (
        <div className={ASSIGNMENT_CARD_WRAPPER_CLASSNAME}>
            <h3 className={ASSIGNMENT_CARD_TITLE_CLASSNAME}>{t('assignment:shootlist_card:title')}</h3>

            <AssignmentCardLink taskCategoryName={assignment.task_category.name} pdfLink={assignment?.pdf_link} />
        </div>
    )
}
